import React from 'react'

import FlexGrid from '../structure/FlexGrid'

const Center = ({ children, ...props }) => (
  <FlexGrid align="center" justify="center" direction="column" children={children} {...props} />
)

export default Center
